import { ItemType } from '@vista-digital/ocapi-types/v1';
import { runInAction } from 'mobx';
import { getInProgressItem } from '../../selectors/items/get-in-progress-item';
export const clearInProgressParentSalesItemSelectedOptions = () => {
    const inProgressItem = getInProgressItem();
    if ((inProgressItem === null || inProgressItem === void 0 ? void 0 : inProgressItem.type) !== ItemType.ParentSales) {
        throw new Error('Cannot update in-progress item options without an in-progress parent sales item.');
    }
    runInAction(() => {
        inProgressItem.selectedInProgressItems = {};
    });
};
